var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route } from "react-router-dom";
import { appRoutes } from "./routes";
import { PublicLayout } from "../layout/PublicLayout";
import { CitizenLayout } from "../layout/CitizenLayout";
import { ProtectedRoute } from "../../components/ProtectedRoute/ProtectedRoute";
var renderRoute = function (_a) {
    var path = _a.path, C = _a.component, isProtected = _a.protected;
    return (_jsx(Route, { path: path, element: isProtected ? (_jsx(ProtectedRoute, { children: _jsx(C, {}) })) : (_jsx(C, {})) }, path));
};
export var RouterManager = function () { return (_jsxs(Routes, { children: [_jsx(Route, __assign({ element: _jsx(PublicLayout, {}) }, { children: appRoutes.filter(function (r) { return r.layout === "public"; }).map(renderRoute) })), _jsx(Route, __assign({ element: _jsx(CitizenLayout, {}) }, { children: appRoutes.filter(function (r) { return r.layout === "citizen"; }).map(renderRoute) }))] })); };
